import {Box, IconButton, Menu, MenuItem, Tooltip} from "@mui/material"
import {clearState} from "../../../../../reducers/targetArticleSlice"
import {resetWorkingArticleNoteRelation} from "../../../../../reducers/workingArticleNoteRelationSlice"
import {Remove, Settings} from "@mui/icons-material"
import {
	initializeDocAttachmentModal, initializeFileAttachmentModal,
	initializeLinkAttachmentModal,
} from "../../../../../reducers/noteAttachmentsSlice"
import {useDispatch} from "react-redux"
import {useRef, useState} from "react"
import {useWorkspaceContext} from "../../../../../pages/Dashboard"

export default function NoteAttachmentMenu({setOpenDeleteModal, preview, attachment}) {
	const dispatch = useDispatch()
	const { workspaceId } = useWorkspaceContext()
	const [openSubMenu, setOpenSubMenu] = useState(false)
	const anchorElRef = useRef(null)
	const handleEditClick = () => {
		if(attachment.attachmentType === "url") {
			dispatch(initializeLinkAttachmentModal({note: attachment.note, actionType: "edit-link", attachment}))
		}
		if(attachment.attachmentType === "doc") {
			dispatch(initializeDocAttachmentModal({note: attachment.note, actionType: "edit-doc", attachment}))
		}
		if(attachment.attachmentType === "file") {
			dispatch(initializeFileAttachmentModal({note: attachment.note, actionType: "edit-file", attachment}))
		}
		setOpenSubMenu(false)
	}
	return (
		<Box
			sx={{
				zIndex: "100",
				position: "absolute",
				top:-1,
				right: 0,
				height: "24px",
				padding: "0px",
				borderBottomLeftRadius: "10px",
				borderLeft: "3px solid rgba(0, 179, 197, 0.5)",
				borderBottom:  "3px solid rgba(0, 179, 197, 0.5)",
				transition: "border-radius 0.06s ease-in-out",
				overflow: "hidden",
			}}
			ref={anchorElRef}
		>
			<Tooltip
				title={"Minimize Attachment"}
			>
				<IconButton
					disabled={preview}
					sx={{
						height: "24px",
						minWidth: "24px",
					}}
					onClick={() => {
						dispatch(clearState(workspaceId))
						dispatch(resetWorkingArticleNoteRelation(workspaceId))
					}}
				>
					<Remove fontSize={"small"}/>
				</IconButton>
			</Tooltip>
			<Tooltip
				title={"Manage Note Attachment"}
				placement={"top"}
			>
				<IconButton
					disabled={preview}
					sx={{
						minWidth: "24px",
					}}
					onClick={() => setOpenSubMenu(true)}
				>
					<Settings fontSize={"small"}/>
				</IconButton>
			</Tooltip>
			<Menu
				open={openSubMenu}
				onClose={() => setOpenSubMenu(false)}
				elevation={0}
				anchorEl={anchorElRef.current}
				anchorOrigin={{
					vertical: "bottom",
					horizontal: "center",
				}}
				transformOrigin={{
					vertical: "top",
					horizontal: "center",
				}}
				MenuListProps={{
					dense: true,
					sx: {
						backgroundColor: "primary.transparency50",
						paddingTop: 0,
						paddingBottom: 0,
					}
				}}
				PaperProps={{
					sx: {
						borderRadius: "2px 0px 0px 10px"
					}
				}}
				TransitionProps={{
					style: {
						transformOrigin: "-1px 0 0"
					}
				}}
			>
				<MenuItem
					onClick={handleEditClick}
					dense
					divider
					sx={{
						justifyContent: "end"
					}}
				>
					{ attachment.attachmentType === "url" && "Edit Note Attachment" }
					{ attachment.attachmentType === "doc" && "Edit Document Title"}
					{ attachment.attachmentType === "file" && "Edit Note File Attachment"}
				</MenuItem>
				<MenuItem
					dense
					onClick={() => {
						setOpenDeleteModal(true)
						setOpenSubMenu(false)
					}}
					sx={{
						justifyContent: "end"
					}}
				>Delete Note Attachment</MenuItem>
			</Menu>
		</Box>
	)
}